@if (isVisible()) {
  <div class="browser-warning">
    <div class="browser-warning__container container">
      <div class="browser-warning__content">
        <span class="browser-warning__icon">
          <fa-icon [icon]="faExclamationCircle" />
        </span>
        <span class="browser-warning__text">
          {{ 'BROWSER_DEPRECATION_WARNING_TEXT' | translate }}
        </span>
      </div>
      <button
        class="browser-warning__close btn btn-outline-light"
        type="button"
        (click)="dismiss()"
        [attr.aria-label]="'CLOSE' | translate"
      >
        <fa-icon [icon]="faTimes" />
      </button>
    </div>
  </div>
}
